import type { FieldValues, Path, UseFormReturn } from 'react-hook-form';

import { fieldErrorFor, type FieldError } from '@/shared/http';

/** Caminhos das folhas de um objeto de formulário (`address.zipCode`, `items.0.name`). */
export function leafPaths(values: unknown, prefix = ''): string[] {
  if (Array.isArray(values)) return values.flatMap((item, index) => leafPaths(item, `${prefix}${String(index)}.`));
  if (typeof values === 'object' && values !== null && !(values instanceof Date)) {
    return Object.entries(values).flatMap(([key, value]) => leafPaths(value, `${prefix}${key}.`));
  }
  return prefix === '' ? [] : [prefix.slice(0, -1)];
}

/**
 * Erros de campo do `INVALID_FORM` (ApiError.fieldErrors) nos campos do formulário, pela regra do
 * legado (`nome.toLowerCase().includes(chave)`, `fieldErrorFor`). Devolve os que não casaram com
 * nenhum campo, para a tela mostrar no aviso do topo.
 */
export function applyApiFieldErrors<V extends FieldValues>(form: UseFormReturn<V>, fieldErrors: readonly FieldError[]): FieldError[] {
  if (fieldErrors.length === 0) return [];
  const names = leafPaths(form.getValues());
  const matched = new Set<FieldError>();
  for (const name of names) {
    const message = fieldErrorFor(fieldErrors, name);
    if (!message) continue;
    const lower = name.toLowerCase();
    for (const error of fieldErrors) if (error.key && lower.includes(error.key)) matched.add(error);
    form.setError(name as Path<V>, { type: 'server', message });
  }
  return fieldErrors.filter((error) => !matched.has(error));
}
